'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getDeviceType = require('./getDeviceType');

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScreenProps = function getScreenProps() {
    return {
        device: {
            type: (0, _getDeviceType2.default)()
        },
        screen: {
            height: window.screen.height,
            width: window.screen.width,
            orientation: window.screen.orientation ? window.screen.orientation.type : null
        }
    };
};

exports.default = getScreenProps;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/getScreenProps.js
// module id = 2560
// module chunks = 1